module.exports = __webpack_public_path__ + "img/club_pc.d5de508.png";